import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCity,
  FaFlag,
  FaBuilding,
  FaEdit,
  FaSave,
  FaTimes,
  FaUserCircle,
  FaCalendarAlt,
  FaIdCard,
} from "react-icons/fa";
import { Link,  } from "react-router-dom";

const ViewProfile = () => {
//   const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    memberSince: "2024-01-15",
    accountStatus: "Active",
    accountType: "Business",
  });

  const [originalData, setOriginalData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Simulate fetching user data from API
    // In a real app, this would come from your backend
    const fetchUserData = () => {
      // Mock data based on registration
      const userData = {
        fullName: "John Doe",
        email: "john.doe@example.com",
        phone: "+1 (555) 123-4567",
        address: "123 Shipping Lane",
        city: "Los Angeles",
        state: "California",
        country: "United States",
        memberSince: "2024-01-15",
        accountStatus: "Active",
        accountType: "Business",
      };
      setProfileData(userData);
      setOriginalData(userData);
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData({
      ...profileData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!profileData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
    } else if (profileData.fullName.trim().length < 3) {
      newErrors.fullName = "Full name must be at least 3 characters";
    }

    if (!profileData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(profileData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!profileData.phone) {
      newErrors.phone = "Phone number is required";
    }

    if (!profileData.address.trim()) {
      newErrors.address = "Address is required";
    }

    if (!profileData.city.trim()) {
      newErrors.city = "City is required";
    }

    if (!profileData.state.trim()) {
      newErrors.state = "State/Province is required";
    }

    if (!profileData.country) {
      newErrors.country = "Country is required";
    }

    return newErrors;
  };

  const handleSave = async () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);

      // Simulate API call
      setTimeout(() => {
        console.log("Profile updated:", profileData);
        setOriginalData(profileData);
        setIsEditing(false);
        setIsLoading(false);
        alert("Profile updated successfully!");
      }, 1500);
    } else {
      setErrors(newErrors);
    }
  };

  const handleCancel = () => {
    setProfileData(originalData);
    setIsEditing(false);
    setErrors({});
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Côte d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const InfoRow = ({
    icon: Icon,
    label,
    value,
    name,
    isEditing: editMode,
    onChange,
    error,
  }) => (
    <div className="info-row">
      <div className="info-label">
        <Icon />
        <span>{label}</span>
      </div>
      {editMode ? (
        <div className="info-value-edit">
          {name === "country" ? (
            <select
              name={name}
              value={value}
              onChange={onChange}
              className={error ? "error" : ""}
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={name === "email" ? "email" : "text"}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={label}
              className={error ? "error" : ""}
            />
          )}
          {error && <span className="field-error">{error}</span>}
        </div>
      ) : (
        <div className="info-value">{value || "Not provided"}</div>
      )}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>My Profile | Trans World Shipping</title>
        <meta
          name="description"
          content="View and manage your Trans World Shipping account profile information."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/profile"
        />
      </Helmet>

      <TheViewProfile>
        <div className="profile-container">
          <div className="profile-card">
            {/* Header */}
            <div className="profile-header">
              <div className="profile-avatar">
                <FaUserCircle />
              </div>
              <div className="profile-title">
                <h1>My Profile</h1>
                <p>Manage your account information</p>
              </div>
              {!isEditing ? (
                <button onClick={handleEdit} className="edit-btn">
                  <FaEdit /> Edit Profile
                </button>
              ) : (
                <div className="action-buttons">
                  <button
                    onClick={handleSave}
                    className="save-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? <span className="spinner"></span> : <FaSave />}
                    {isLoading ? "Saving..." : "Save Changes"}
                  </button>
                  <button onClick={handleCancel} className="cancel-btn">
                    <FaTimes /> Cancel
                  </button>
                </div>
              )}
            </div>

            {/* Account Summary Cards */}
            <div className="account-summary">
              <div className="summary-card">
                <FaCalendarAlt className="summary-icon" />
                <div className="summary-info">
                  <span className="summary-label">Member Since</span>
                  <span className="summary-value">
                    {profileData.memberSince}
                  </span>
                </div>
              </div>
              <div className="summary-card">
                <FaIdCard className="summary-icon" />
                <div className="summary-info">
                  <span className="summary-label">Account Status</span>
                  <span className="summary-value status-active">
                    {profileData.accountStatus}
                  </span>
                </div>
              </div>
              <div className="summary-card">
                <FaBuilding className="summary-icon" />
                <div className="summary-info">
                  <span className="summary-label">Account Type</span>
                  <span className="summary-value">
                    {profileData.accountType}
                  </span>
                </div>
              </div>
            </div>

            {/* Profile Information */}
            <div className="profile-info">
              <h2>Personal Information</h2>
              <div className="info-grid">
                <InfoRow
                  icon={FaUser}
                  label="Full Name"
                  name="fullName"
                  value={profileData.fullName}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.fullName}
                />

                <InfoRow
                  icon={FaEnvelope}
                  label="Email Address"
                  name="email"
                  value={profileData.email}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.email}
                />

                <InfoRow
                  icon={FaPhone}
                  label="Phone Number"
                  name="phone"
                  value={profileData.phone}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.phone}
                />
              </div>
            </div>

            <div className="profile-info">
              <h2>Address Information</h2>
              <div className="info-grid">
                <InfoRow
                  icon={FaMapMarkerAlt}
                  label="Address"
                  name="address"
                  value={profileData.address}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.address}
                />

                <InfoRow
                  icon={FaCity}
                  label="City"
                  name="city"
                  value={profileData.city}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.city}
                />

                <InfoRow
                  icon={FaBuilding}
                  label="State/Province"
                  name="state"
                  value={profileData.state}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.state}
                />

                <InfoRow
                  icon={FaFlag}
                  label="Country"
                  name="country"
                  value={profileData.country}
                  isEditing={isEditing}
                  onChange={handleChange}
                  error={errors.country}
                />
              </div>
            </div>

            {/* Security Section */}
            <div className="profile-info security-section">
              <h2>Security</h2>
              <div className="security-actions">
                <Link to="/change-password" className="security-link">
                  Change Password
                </Link>
                <Link to="/login" className="security-link">
                  Login Activity
                </Link>
              </div>
            </div>

            {/* Danger Zone */}
            <div className="danger-zone">
              <h3>Danger Zone</h3>
              <div className="danger-actions">
                <button
                  className="delete-btn"
                  onClick={() =>
                    alert("Account deletion would be handled here")
                  }
                >
                  Deactivate Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </TheViewProfile>
    </>
  );
};

const TheViewProfile = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9edf2 100%);
  padding: 2rem;

  .profile-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  .profile-card {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .profile-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 2px solid #e2e8f0;
    flex-wrap: wrap;

    .profile-avatar {
      svg {
        font-size: 4rem;
        color: #d4af37;
      }
    }

    .profile-title {
      flex: 1;

      h1 {
        font-size: 1.8rem;
        color: #0b1e33;
        margin-bottom: 0.25rem;
        font-weight: 700;
      }

      p {
        color: #718096;
        font-size: 0.9rem;
      }
    }

    .edit-btn {
      background: #d4af37;
      color: #0b1e33;
      border: none;
      padding: 0.6rem 1.2rem;
      border-radius: 8px;
      font-size: 0.9rem;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.3s ease;

      &:hover {
        background: #c4a12e;
        transform: translateY(-2px);
      }
    }

    .action-buttons {
      display: flex;
      gap: 0.75rem;

      .save-btn,
      .cancel-btn {
        padding: 0.6rem 1.2rem;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.3s ease;
        font-family: inherit;
      }

      .save-btn {
        background: #4caf50;
        color: white;
        border: none;

        &:hover:not(:disabled) {
          background: #45a049;
          transform: translateY(-2px);
        }

        &:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      }

      .cancel-btn {
        background: #e2e8f0;
        color: #4a5568;
        border: none;

        &:hover {
          background: #cbd5e0;
          transform: translateY(-2px);
        }
      }
    }
  }

  .account-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin-bottom: 2rem;

    .summary-card {
      background: #f8f9fa;
      padding: 1rem;
      border-radius: 12px;
      display: flex;
      align-items: center;
      gap: 1rem;
      border: 1px solid #e2e8f0;

      .summary-icon {
        font-size: 2rem;
        color: #d4af37;
      }

      .summary-info {
        display: flex;
        flex-direction: column;

        .summary-label {
          font-size: 0.75rem;
          color: #718096;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .summary-value {
          font-size: 1rem;
          font-weight: 700;
          color: #0b1e33;

          &.status-active {
            color: #4caf50;
          }
        }
      }
    }
  }

  .profile-info {
    margin-bottom: 2rem;

    h2 {
      font-size: 1.3rem;
      color: #0b1e33;
      margin-bottom: 1rem;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #e2e8f0;
    }

    .info-grid {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .info-row {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      padding: 0.75rem;
      background: #f8f9fa;
      border-radius: 10px;

      .info-label {
        min-width: 140px;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #0b1e33;
        font-weight: 600;

        svg {
          color: #d4af37;
          font-size: 1rem;
        }

        span {
          font-size: 0.9rem;
        }
      }

      .info-value {
        flex: 1;
        color: #4a5568;
        font-size: 0.9rem;
        word-break: break-word;
      }

      .info-value-edit {
        flex: 1;

        input,
        select {
          width: 100%;
          padding: 0.6rem;
          border: 1.5px solid #e2e8f0;
          border-radius: 8px;
          font-size: 0.9rem;
          font-family: inherit;

          &:focus {
            outline: none;
            border-color: #d4af37;
          }

          &.error {
            border-color: #e53e3e;
          }
        }

        .field-error {
          display: block;
          margin-top: 0.25rem;
          font-size: 0.75rem;
          color: #e53e3e;
        }
      }
    }
  }

  .security-section {
    .security-actions {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;

      .security-link {
        background: #f8f9fa;
        color: #0b1e33;
        text-decoration: none;
        padding: 0.6rem 1.2rem;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 500;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;

        &:hover {
          border-color: #d4af37;
          color: #d4af37;
        }
      }
    }
  }

  .danger-zone {
    margin-top: 2rem;
    padding: 1rem;
    background: #fff5f5;
    border-radius: 12px;
    border: 1px solid #fed7d7;

    h3 {
      color: #e53e3e;
      font-size: 1rem;
      margin-bottom: 1rem;
    }

    .danger-actions {
      .delete-btn {
        background: transparent;
        border: 1px solid #e53e3e;
        color: #e53e3e;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        cursor: pointer;
        font-size: 0.85rem;
        transition: all 0.3s ease;

        &:hover {
          background: #e53e3e;
          color: white;
        }
      }
    }
  }

  .spinner {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid white;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1rem;

    .profile-card {
      padding: 1.5rem;
    }

    .profile-header {
      flex-direction: column;
      text-align: center;

      .profile-title {
        text-align: center;
      }
    }

    .account-summary {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }

    .info-row {
      flex-direction: column;

      .info-label {
        min-width: auto;
      }

      .info-value-edit {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .profile-card {
      padding: 1rem;
    }

    .profile-header h1 {
      font-size: 1.5rem;
    }

    .action-buttons {
      flex-direction: column;
      width: 100%;

      .save-btn,
      .cancel-btn {
        justify-content: center;
      }
    }

    .security-actions {
      flex-direction: column;

      .security-link {
        text-align: center;
      }
    }
  }
`;

export default ViewProfile;
